// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupOwner_container__3Qe_A","body":"GroupOwner_body__3a7G_","scrollContent":"GroupOwner_scrollContent__81uJ-"};